import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { PageLoadingSkeletonTraits } from 'traits/page-loading-skeleton-traits';
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { PageDocsItem } from "components/pages/page-docs-item";
import { ScrollSpyTraits } from "traits/scroll-spy-traits";

export class PageReference extends ViewStream {
  constructor(props = {}) {
    props.traits = [PageTraits,PageLoadingSkeletonTraits, ScrollSpyTraits];
    props.data = safeClone(props.pageData);
    props.id = "l1-Reference";
    props.class = "app-page";
    props.disableScrollSpy = false;
    props.scrollOffsetY = 50;
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    props.template = require("./templates/page-reference.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"],
      ["CHANNEL_ROUTE_DEEPLINK_EVENT", "page$OnDeepLink"],
      ["CHANNEL_ROUTE_CHANGE_EVENT", "page$ScrollSectionIntoView"],
    ];
  }

  onBeforeDispose() {
    this.scrollSpy$Unsubscribe();
  }

  onPageChangeEvent(e) {
    const { pageId } = e.payload.routeData;
   //console.log("this props ", this.props);

    if (pageId !== this?.props?.pageId) {
      this.disposeViewStream();
    } else {
      this.page$ScrollSectionIntoView(e);
      this.props.pageLoaded = true;
    }
  }

  broadcastEvents() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? [["a", "click"]] : [];
    return broadcastEls;
  }

  addPageDocItems() {
    const { pageId } = this.props;
    const addPageItems = (data) => {
      this.appendView(new PageDocsItem({ data, pageId }), ".page-content");
    };

    this.props.appData.referencePageContent.forEach(addPageItems);
   //console.log("ADDED ALL ITEMS ");
  }

  onRendered() {
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();
    this.scrollSpy$SubscribeAndSendToRoute();
    // Long initial hold — outlasts the ~800ms deep-link scroll delay
    // (see PageDocs.onRendered); resumes on scroll settle.
    this.scrollSpy$PauseScrollSpy(this.props, 1200);
    this.addChannel("CHANNEL_ROUTE");
    const delayAddSkeleton = () => this.pageSkeleton$LoadSkeleton(
        ".code-container-reference-holder");

    //requestAnimationFrame(delayAddSkeleton);

    window.setTimeout(delayAddSkeleton, 50);
    //console.log('page reference ');

    const onHideSkel = () => this.pageSkeleton$RemoveSkeleton();

    //window.setTimeout(onHideSkel, 3000);
    const addReveal = () => {

      if (this?.props){
        this.props.el$(".page-content.page-reference-content").addClass('reveal');
      }
  }

    window.setTimeout(addReveal, 770);

  }
}
